var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * @Author: yejianfei
 * @Date: 2023-04-03 22:34:45
 * @LastEditors: yejianfei
 * @LastEditTime: 2023-04-17 10:23:46
 * @Description:
 * @Developer:
 */
import React from 'react';
import AdminPage from '../../components/antd/AdminPage';
import { Button, Card, Col, Form, Input, Row, Space } from 'antd';
import APITable from '../../components/antd/APITable';
import Separator from '../../components/Separator';
import WithRouter from '../../components/WithRouter';
import APICascader from '../../components/antd/APICascader';
import IconFont from '../../icons';
let AdminDiagnosticListPage = class AdminDiagnosticListPage extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {};
    }
    render() {
        return (React.createElement(AdminPage, null,
            React.createElement(Card, { style: { height: '100%' }, bodyStyle: { padding: 12, height: '100%' } },
                React.createElement(APITable, { bordered: true, tableLayout: 'fixed', loader: `/admin/diagnostics/list/:page?type=treatment_item`, initialParams: {
                        page: 1,
                        size: 25,
                        filters: true
                    }, size: 'small', rowKey: 'id', 
                    // scroll={{y: 100}}
                    pagination: { showSizeChanger: false }, columns: [{
                            title: '项目名称',
                            width: 200,
                            align: 'center',
                            dataIndex: 'name'
                        }, {
                            title: '所属医院',
                            width: 200,
                            align: 'center',
                            dataIndex: ['parent', 'parent', 'name']
                        }, {
                            title: '所属科室',
                            width: 200,
                            align: 'center',
                            dataIndex: ['parent', 'name'],
                        }, {
                            title: '操作',
                            dataIndex: 'operation',
                            align: 'center',
                            width: 200,
                            render: ((text, record, index, instance) => {
                                return (React.createElement(Space, null,
                                    React.createElement(Button, { type: "link", onClick: () => instance.modal(record.id) }, "\u7F16\u8F91"),
                                    React.createElement(Button, { danger: true, type: "link", onClick: () => instance.delete(record.id) }, "\u5220\u9664")));
                            })
                        }], search: {
                        children: (table) => {
                            return (React.createElement(Row, null,
                                React.createElement(Col, { span: 4 },
                                    React.createElement(Form.Item, { name: ['path'] },
                                        React.createElement(APICascader, { loader: {
                                                root: '/admin/organizations/tree/:path/children?type=hospital',
                                                children: '/admin/organizations/tree/:path/children',
                                            }, params: {
                                                path: 'root'
                                            }, depth: 2, cascadeParamName: 'path', placeholder: '\u6309\u533B\u9662\u53CA\u79D1\u5BA4\u8FC7\u6EE4', fieldNames: {
                                                label: 'name',
                                                value: 'id',
                                                path: 'full_path'
                                            }, onChange: (value) => {
                                                console.log('ccc', value);
                                            } }))),
                                React.createElement(Separator, { direction: 'horizontal', size: 8 }),
                                React.createElement(Col, { span: 8 },
                                    React.createElement(Form.Item, { name: ['keywords'] },
                                        React.createElement(Input.Search, { placeholder: '\u8F93\u5165\u8BCA\u7597\u9879\u76EE\u540D\u79F0\u68C0\u7D22', allowClear: true, enterButton: true, onSearch: () => table.search() }))),
                                React.createElement(Col, { flex: 1 },
                                    React.createElement(Row, { justify: 'end' },
                                        React.createElement(Space, null,
                                            React.createElement(Form.Item, null,
                                                React.createElement(Button, { onClick: () => table.modal(), icon: React.createElement(IconFont, { type: 'icon-diagnosis-add' }) })))))));
                        }
                    }, form: {
                        title: '诊疗项目',
                        action: '/admin/organizations',
                        loader: '/admin/organizations/:id',
                        name: 'user-form',
                        initialValues: {
                            type: 'treatment_item',
                        },
                        onLoaded: (values) => __awaiter(this, void 0, void 0, function* () { return (Object.assign(Object.assign({}, values), { password: Date.now() })); }),
                        children: (values) => (React.createElement(React.Fragment, null,
                            React.createElement(Form.Item, { label: '\u9879\u76EE\u540D\u79F0', labelCol: { span: 5 }, name: ['name'], rules: [{ required: true, message: '请输入诊疗项目名称' }] },
                                React.createElement(Input, { placeholder: '\u8BF7\u8F93\u5165\u8BCA\u7597\u9879\u76EE\u540D\u79F0' })),
                            React.createElement(Form.Item, { label: '\u6240\u5C5E\u79D1\u5BA4', labelCol: { span: 5 }, name: ['path'], rules: [{ required: true, message: '请选择' }] },
                                React.createElement(APICascader, { loader: {
                                        root: '/admin/organizations/tree/:path/children?type=hospital',
                                        children: '/admin/organizations/tree/:path/children',
                                    }, params: {
                                        path: 'root'
                                    }, depth: 2, cascadeParamName: 'path', placeholder: '\u9009\u62E9\u6240\u5C5E\u533B\u9662\u53CA\u79D1\u5BA4', fieldNames: {
                                        label: 'name',
                                        value: 'id',
                                        path: 'full_path'
                                    } }))))
                    } }))));
    }
};
AdminDiagnosticListPage = __decorate([
    WithRouter()
], AdminDiagnosticListPage);
export default AdminDiagnosticListPage;
